import { GET_TOP_REVENUE_PRODUCTS, TOP_REVENUE_PRODUCTS_LOADING } from '../actions/types';

const initialState = {
  loading: false,
  products: [],
};

function reducer(state = initialState, action: { type: string; payload?: any }) {
  switch (action.type) {
    case TOP_REVENUE_PRODUCTS_LOADING:
      return { ...state, loading: true };
    case GET_TOP_REVENUE_PRODUCTS:
      return { ...state, loading: false, products: action.payload };
    default:
      return state;
  }
}

export default reducer;
